
const m = window.require("@catalog/shared/clients/stock-orders-client");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
